// src/api/Contactapi.js
import api from "../api/Restapi";

export const sendContactForm = async (formData) => {
  try {
    const response = await api.post("/contact", formData);
    return response.data;
  } catch (error) {
    return {
      status: false,
      message: "Something went wrong",
      errors: error?.response?.data || error?.message,
    };
  }
};
